import card01 from '../asset/card01.jpg';
import imgTeach from '../asset/teach.jpg';
import imgTools from '../asset/tools.jpg';
import imgBBS from '../asset/bbs.jpg';
import imgPrompt from '../asset/prompt.jpg';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import ReactMarkdown from 'react-markdown'

import './SimpleList.css';


const listMarkdownTutorial = `
  ### 国外教程

  - [A-Traveler-s-Guide-to-the-Latent-Space](https://sweet-hall-e72.notion.site/A-Traveler-s-Guide-to-the-Latent-Space-85efba7e5e6a40e5bd3cae980f30235f#68987404382d4807b57204429d50e53d) - In depth guide for prompt engineering. 
  - [Dalle2 prompt book](https://dallery.gallery/the-dalle-2-prompt-book/) - A great, visual intro to prompt creation by [@guyp](https://twitter.com/guyp) - Dalle focused

  (待补充...)

  ### 国内教程

  (待补充...)
`;

const listMarkdownTools = `
  ### 免费在线创作（国内）

  (待补充...)

  ### 付费在线创作（国内）

  (待补充...)

  ### 免费在线创作（海外）

  - [Craiyon](https://www.craiyon.com/) - Formerly dalleMini - open source tool that outputs great compositions but lower quality
  - [StableDiffusion on HuggingFace](https://huggingface.co/spaces/stabilityai/stable-diffusion) - Run the #StableDiffusion right in huggingface UI 
  - [StableDiffusion on Replicate](https://replicate.com/stability-ai/stable-diffusion) - Run #StableDiffusionon on replicate.com 
  - [Google Colab](https://colab.research.google.com/) - Google free GPU machines in the cloud running models of all sorts.

  (待补充...)

  ### 付费在线创作（海外）
  - [DreamStudio](https://beta.dreamstudio.ai/) - #StableDiffusion in the cloud 
  - [Midjourney](https://www.midjourney.com/app/) - Discord bot with amazing visuals
  - [Dalle2](https://labs.openai.com/) - The one that started it all, great with multi characters
  - [NightCafe](https://creator.nightcafe.studio/) - Nightcafe studio is an AI Art Generator (incrorporates stableDiffusion)
  - [ArtBreeder Collage](https://collage.artbreeder.com/) - A collaging tool to generate art using visual aides.
  - [Photoroom](https://www.photoroom.com/backgrounds/) - Photoroom has a new feature for backgrounds (featured on product hunt)

  (待补充...)

  ### 免费本地创作（国外）

  - [StableDiffusion + Web GUI](https://github.com/hlky/stable-diffusion-webui) - 中文社区版是在这个基础上二次开发而成的

  ### 创作辅助工具

  - [WebUI repo](#free-local) has upscalers built in!
  - [real-esrgan](https://replicate.com/nightmareai/real-esrgan) - A hosted version of real-ERSGan with optional face correction
  - [Cupscale](https://github.com/n00mkrad/cupscale) - Windows app that upscales with ERSGan on your GPU
  - [chaiNNer](https://github.com/joeyballentine/chaiNNer) - A flowchart/node-based image processing GUI for Windows, MacOS, and Linux
  - [修复脸部](#)

  (待补充...)
`;

const listMarkdownPrompt = `
  ### Prompt图集（国内）

  (待补充...)

  ### Prompt图集（海外）

  - [Lexica](https://lexica.art/) - A Stable Diffusion prompts search engine
  - [Libraire](https://libraire.ai/) - Another Stable Diffusion prompts search engine, with over 10M images and prompts
  - [Krea.ai](https://www.krea.ai/) - A prompt builder with a nice UI, searchable prompts.
  - [PromptMania prompt builder](https://promptomania.com/prompt-builder/) - A prompt builder that supports MJ, SD and Dalle, with visual examples and a lot of modifiers
  - [Promptbase Marketplace](https://promptbase.com/) - Buy and sell your promtps for 💰
  - [GPT-2 prompt generator](https://huggingface.co/succinctly/text2image-prompt-generator) - A GPT2 model trained to autocomplete MJ prompts
  

  (待补充...)

  ### 艺术家、风格研究 
  
  - [Stable diffusion artist study](https://proximacentaurib.notion.site/e2537cbf42c34b7e9a9a4126f81dfd0d?v=7b4a3c03fb654045be324eb71acc57e6) - A huge list of artist (no living) with examples by ([@sureailabs](https://twitter.com/sureailabs), [@proximasan](https://twitter.com/proximasan), [@EErratica](https://twitter.com/EErratica), and [@KyrickYoung](https://twitter.com/KyrickYoung))
  - [Stable Diffusion Portrait Prompt Study](http://stable-diffusion-guide.s3-website-us-west-2.amazonaws.com/v2/people.html) - A great resource for seeing how different prompts change the style and effects of portrait images.
  - [Stable Diffusion Artist Style Comparison](https://www.reddit.com/r/StableDiffusion/comments/x6rjpz/artists_style_comparison/) - A great resource shwoing off artists' styles using the same prompt.
  - [StableDiffusion modifier study](https://proximacentaurib.notion.site/2b07d3195d5948c6a7e5836f9d535592?v=b5b75a67cc52483c9965cfc141f6f582) - A great study of modifiers that can enhance your prompts significantly
  - [Google doc with 3800+ artists and styles](https://docs.google.com/document/u/0/d/1SaQx1uJ9LBRS7c6OsZIaeanJGkUdsUBjk9X4dC59BaA) - Great collaborative effort 3800+ artists and styles + tips for prompting. Continuesly updated. (without generated images)

  ### 其他文本工具

  - [CLIP interrogator](https://github.com/pharmapsychotic/clip-interrogator) - Convert uploaded images into prompts by [@pharampsychotic](https://twitter.com/pharmapsychotic) [![Open In Colab](https://colab.research.google.com/assets/colab-badge.svg)](https://colab.research.google.com/github/pharmapsychotic/clip-interrogator/blob/main/clip_interrogator.ipynb)
  - [img2prompt](https://replicate.com/methexis-inc/img2prompt) - Hosted version of CLIP interrogator on Replicate. Upload image, get prompt ideas. 
  - [same.energy](https://same.energy) - A visual exploration search engine. 
  - [CLIP retrieval](https://rom1504.github.io/clip-retrieval/?back=https%3A%2F%2Fknn5.laion.ai&index=laion5B&useMclip=false) - Allows you to browse the major datasets the img-2-text models were trained on. 

`;

const listMarkdownBBS = `
  ### 国内网址

  (待补充...)

  ### 国外网址

  - [Stable Diffusion discord](https://discord.gg/stablediffusion) - A great community with folks who help each other
  - [MidJourney](https://discord.com/invite/midjourney) - A huge community of image synthesis folks, prompt help, inspiration channels, etc
  - [r/StableDiffusion](https://www.reddit.com/r/StableDiffusion/) - A rapidly growing Subreddit for Stable Diffusion related content - Community Run
  - [r/MidJourney](https://www.reddit.com/r/midjourney/) - The official subreddit for MidJourney related Content

  (待补充...)

`;


export default function SimpleList() {
  return (
    <Container fluid="md">
      <> 
        <div className="projects-header">
          <h2>资源列表</h2>
        </div>
        <Row>
          <Col sm={12} md={12} lg={6}> <CardTutorial/> </Col>
          <Col sm={12} md={12} lg={6}> <CardTools/> </Col>
          <Col sm={12} md={12} lg={6}> <CardPrompt/> </Col>
          <Col sm={12} md={12} lg={6}> <CardBBS/> </Col>
        </Row>
      </>
    </Container>
  )
}

function CardTutorial() {
  return (
    <Card style={{marginBottom: '20px'}} id="tutorial">
      <Card.Body>
        <Card.Title>入门教程</Card.Title>
        <a href="https://ai2art.github.io/articles/sd-tutorial-for-beginers/" target="_blank">
          <Card.Img style={{marginBottom: '10px'}} src={imgTeach} />
        </a>
        <Card.Text>一文教你入门stable diffusion…</Card.Text>
        <Accordion defaultActiveKey="0">
          <Accordion.Header>更多教程...</Accordion.Header>
          <Accordion.Body className="simple-card-sub">
            <ReactMarkdown children={listMarkdownTutorial} />
          </Accordion.Body>
        </Accordion>
      </Card.Body>              
    </Card>    
  )
}

function CardTools() {
  return (
    <Card style={{marginBottom: '20px'}} id="tools">
      <Card.Body>
        <Card.Title>软件工具</Card.Title>
        <a href="https://ai2art.github.io/articles/sd-tool-download/" target="_blank"><Card.Img style={{marginBottom: '10px'}} src={imgTools} /></a>
        <Card.Text>社区免费版工具，解压即用，自带中文翻译...</Card.Text>
        <Accordion defaultActiveKey="0">
          <Accordion.Header>更多工具...</Accordion.Header>
          <Accordion.Body className="simple-card-sub">
            <ReactMarkdown children={listMarkdownTools} />
          </Accordion.Body>
        </Accordion>
      </Card.Body>              
    </Card>    
  )
}

function CardPrompt() {
  return (
    <Card style={{marginBottom: '20px'}} id="prompt">
      <Card.Body>
        <Card.Title>文本工程(Prompt Engineering)</Card.Title>
          <a href="https://lexica.art/" target="_blank">
            <Card.Img style={{marginBottom: '10px'}} src={imgPrompt} />
          </a>
        <Card.Text>中文网站建设中，目前<a href="https://lexica.art/" target="_blank">lexia.art</a>是一个优秀的英文Prompt网站，您可以参考</Card.Text>
        <Accordion defaultActiveKey="0">
          <Accordion.Header>更多资源...</Accordion.Header>
          <Accordion.Body className="simple-card-sub">
            <ReactMarkdown children={listMarkdownPrompt} />
          </Accordion.Body>
        </Accordion>
      </Card.Body>              
    </Card>    
  )
}

function CardBBS() {
  return (
    <Card style={{marginBottom: '20px'}} id="bbs">
      <Card.Body>
        <Card.Title>论坛网站</Card.Title>
        <a target="_blank" href="https://qm.qq.com/cgi-bin/qm/qr?k=FIz8CmkavOB5GYwoR8xjBVJ95WJalQXJ&jump_from=webapi&authKey=+zj6q+B3kNrZWCMFoxi8W56mKAg5uvvxWe8JPe6YVRKXPIU3cKd37mkbQVH5x+Se">
        <Card.Img style={{marginBottom: '10px'}} src={imgBBS} /></a>
        <Card.Text>中文社区bot搭建中，目前qq群号：705791701 可供参考</Card.Text>
        <Accordion defaultActiveKey="0">
          <Accordion.Header>更多网站...</Accordion.Header>
          <Accordion.Body className="simple-card-sub">
            <ReactMarkdown children={listMarkdownBBS} />
          </Accordion.Body>
        </Accordion>
      </Card.Body>              
    </Card>    
  )
}